import React, { Fragment, useState } from "react";
import Page from "../components/Page/Page";
import './Delivery.scss';
import Logo from "../static/Uber-Eats-Logo.png";
import Logo2 from "../static/skipthedisheslogo.jpg";
import Logo3 from "../static/doordashlogo.png";

function Delivery() {
	return (
		<Page id={"delivery"} customClass={"pad-top-for-menu"}>
			<div className="delivery">
				<a
					className="link link2"
					href="https://www.skipthedishes.com/genji-sushi-2899-steeles-avenue-west"
				>
					<span className="text">Click to go to</span>
					<img
						className="logo logo2"
						src={Logo2}
						alt="skip the dishes logo"
					/>
				</a>
				<a
					className="link"
					href="https://www.ubereats.com/ca/store/genji-sushi/amrkcg41V6OsjspPOcGJCw/e2509b01-c70e-5d3d-aae8-71f96792b06c"
				>
					<span className="text">Click to go to</span>
					<img className="logo" src={Logo} alt="uber eats logo" />
				</a>
				<a
					className="link"
					href="https://www.doordash.com/en-CA/store/genji-sushi-toronto-35737735/78113746/"
				>
					<span className="text">Click to go to</span>
					<img className="logo doordash" src={Logo3} alt="door dash logo" />
				</a>
			</div>
		</Page>
	);
}

export default Delivery;
